import { type TableOptions } from '@tanstack/react-table';
import { useMemo } from 'react';

import type { DataTableVisualVariantProps } from './visual-variants-types.js';
import { useDataTableConfigElement } from '../../../hooks/useDataTableConfig.js';
import { DATA_TABLE_VISUAL_VARIANT_CONFIG_DEFAULT } from '../../constants.js';
import type { DataTableRowData } from '../../row-data-types.js';
import type { TDataTableFeatures } from '../types/features.types.js';

/**
 * @internal Configuration hook for the VisualVariant feature.
 *
 */
export function useVisualVariant<TData extends DataTableRowData>(
  props: DataTableVisualVariantProps,
  options: TableOptions<TDataTableFeatures, Exclude<TData, unknown>>,
) {
  const configVariant = useDataTableConfigElement('variant');

  const visualVariantConfig = useMemo(() => {
    return {
      rowSeparation:
        props.variant?.rowSeparation ??
        configVariant?.rowSeparation ??
        DATA_TABLE_VISUAL_VARIANT_CONFIG_DEFAULT.rowSeparation,
      verticalDividers:
        props.variant?.verticalDividers ??
        configVariant?.verticalDividers ??
        DATA_TABLE_VISUAL_VARIANT_CONFIG_DEFAULT.verticalDividers,
      contained:
        props.variant?.contained ??
        configVariant?.contained ??
        DATA_TABLE_VISUAL_VARIANT_CONFIG_DEFAULT.contained,
      rowDensity:
        props.variant?.rowDensity ??
        configVariant?.rowDensity ??
        DATA_TABLE_VISUAL_VARIANT_CONFIG_DEFAULT.rowDensity,
      fontStyle:
        props.variant?.fontStyle ??
        configVariant?.fontStyle ??
        DATA_TABLE_VISUAL_VARIANT_CONFIG_DEFAULT.fontStyle,
      headers:
        props.variant?.headers ??
        configVariant?.headers ??
        DATA_TABLE_VISUAL_VARIANT_CONFIG_DEFAULT.headers,
      verticalAlignment:
        props.variant?.verticalAlignment ??
        configVariant?.verticalAlignment ??
        DATA_TABLE_VISUAL_VARIANT_CONFIG_DEFAULT.verticalAlignment,
    };
  }, [props.variant, configVariant]);

  // eslint-disable-next-line react-hooks/immutability
  options.state = {
    ...options.state,
    visualVariantConfig,
  };
}
